module.exports = __webpack_public_path__ + "162722e600c25cdf841d006e11440bde.png";